/**
 * Created by FeNiX on 19-Aug-16.
 */
import React, { Component } from 'react';
import {api} from "../rest";
import swal from "sweetalert2";
import Loading from "./loading";
import ServicesStore from "../stores/ServicesStore";

export default class FormContractor extends Component {
	constructor() {
		super();
		this.initialState = {
			contractor: "",
			color: "",
			fetching: false
		};
		this.state = this.initialState;
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleContractorChange = this.handleContractorChange.bind(this);
		this.handleColorChange = this.handleColorChange.bind(this);
	}
	handleFormSubmit (e) {
		e.preventDefault();
		this.setState({fetching: true});
		api.post(`/contractors`,{name: this.state.contractor, color: this.state.color || null})
		.then(()=>{
			swal("Contratante creado","","success");
			this.setState(this.initialState);
			api.get("contractors")
			.then((response)=>{
				ServicesStore.setContractor(response.data)
			})
			.catch((error)=>{
				console.error(error);
			})
		})
		.catch((error)=>{
			if (error.response) {
				if (error.response.status === 406) {
					swal("Error", `Ya existe un contrante con ese nombre`,"error");
				} else {
					swal("Error", `Status: ${status}`,"error");
				}
			} else {
				console.log(error);
			}
		})
		.then(()=>{
			this.setState({fetching: false});
		})
	}
	handleContractorChange({target: {value}}) {
		this.setState({contractor: value});
	}
	handleColorChange({target: {value}}) {
		this.setState({color: value});
	}
	render() {
		return (
			<form className="group columns small-12" onSubmit={this.handleFormSubmit}>
				<Loading loading={this.state.fetching}/>
				<div className="group-title">Crear nuevo contratante</div>
				<div className="row">
					<label className="columns small-6">
						<em>Contratante</em>
						<input type="text" value={this.state.contractor} onChange={this.handleContractorChange} required/>
					</label>
					<label className="columns small-2">
						<em>Color</em>
						<input type="color" value={this.state.color} onChange={this.handleColorChange}/>
					</label>
					<label className="columns small-4">
						<em> </em>
						<button type="submit" className="button success expanded" disabled={this.state.fetching}>Guardar</button>
					</label>
				</div>
			</form>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/form_contractor.js
 **/